var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5252 28.3655H1.47477C0.991649 28.3655 0.6 27.9739 0.6 27.4907V1.47477C0.6 0.99165 0.99165 0.6 1.47477 0.6H16.2395C16.7226 0.6 17.1143 0.991649 17.1143 1.47477V5.53848C17.1143 6.27709 17.7131 6.87586 18.4517 6.87586H22.5252C23.0084 6.87586 23.4 7.26751 23.4 7.75064V27.4907C23.4 27.9739 23.0084 28.3655 22.5252 28.3655Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5252 28.3655H1.47477C0.991649 28.3655 0.6 27.9739 0.6 27.4907V1.47477C0.6 0.99165 0.99165 0.6 1.47477 0.6H17.1041C17.3359 0.6 17.5582 0.691975 17.7222 0.85573L23.1433 6.26837C23.3076 6.43246 23.4 6.65517 23.4 6.88741V27.4907C23.4 27.9739 23.0084 28.3655 22.5252 28.3655Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.8789L12 11.8789",
    stroke: "#1A1B1D",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.3789H7.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationIcon);
export default __webpack_public_path__ + "static/media/illustration-icon.838d0e7f787ff74579ad72559fe79a6a.svg";
export { ForwardRef as ReactComponent };